// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.9d88d4bbe',
  revision: '9d88d4bbe',
  branch: 'develop',
  date: 'Mon, 25 May 2026 10:59:27 GMT'
};